import * as Sentry from '@sentry/react';
import { AxiosError, isAxiosError, isCancel } from 'axios';
import { Primitive } from 'zod';

export default function captureSentryException(
  error: unknown,
  {
    message,
    tags = {},
    extras = {},
  }: {
    message?: string;
    tags?: {
      feature?: string;
      from?: string;
    } & Record<string, Primitive>;
    extras?: Record<string, unknown>;
  } = {}
) {
  // if (import.meta.env.DEV) {
  //   console.error(error);
  //   return
  // }

  if (isCancel(error)) {
    Sentry.withScope((scope) => {
      const axiosError = error as AxiosError;
      if (message) scope.setExtra('message', message ?? 'axios request was cancelled');
      scope.setTag('from', 'axios');
      if (axiosError.config) {
        scope.setExtra('request_config', axiosError.config);
      }
      for (const [key, value] of Object.entries(tags)) scope.setTag(key, value);
      for (const [key, value] of Object.entries(extras)) scope.setExtra(key, value);
      Sentry.captureException(axiosError);
    });
  } else if (isAxiosError(error)) {
    const axiosError = error as AxiosError;
    Sentry.withScope((scope) => {
      if (message) scope.setExtra('message', message);
      scope.setTag('from', 'axios');
      if (axiosError.config) {
        scope.setExtra('request_config', axiosError.config);
      }
      if (axiosError.response) {
        scope.setExtra('response_data', axiosError.response.data);
        scope.setExtra('response_status', axiosError.response.status);
        scope.setExtra('response_headers', axiosError.response.headers);
      }
      for (const [key, value] of Object.entries(tags)) scope.setTag(key, value);
      for (const [key, value] of Object.entries(extras)) scope.setExtra(key, value);
      Sentry.captureException(axiosError);
    });
  } else {
    Sentry.withScope((scope) => {
      if (message) scope.setExtra('message', message);
      for (const [key, value] of Object.entries(tags)) scope.setTag(key, value);
      for (const [key, value] of Object.entries(extras)) scope.setExtra(key, value);
      Sentry.captureException(error);
    });
  }
}
